import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { es, en, Textos } from "./textos";

export type Idioma = "es" | "en";

interface IdiomaValor {
  idioma: Idioma;
  cambiarIdioma: (idioma: Idioma) => void;
  /** Textos del idioma activo (tipados: `t.hero.titulo`). */
  t: Textos;
}

const CLAVE = "vuc-idioma";
const DICCIONARIOS: Record<Idioma, Textos> = { es, en };

const leerGuardado = (): Idioma => {
  try {
    const v = window.localStorage.getItem(CLAVE);
    return v === "en" ? "en" : "es";
  } catch {
    return "es";
  }
};

const IdiomaContext = createContext<IdiomaValor>({ idioma: "es", cambiarIdioma: () => {}, t: es });

/** Proveedor del idioma del portal: recuerda la elección y actualiza <html lang>. */
export const IdiomaProvider = ({ children }: { children: React.ReactNode }) => {
  const [idioma, setIdioma] = useState<Idioma>(leerGuardado);

  useEffect(() => {
    document.documentElement.lang = idioma;
    try {
      window.localStorage.setItem(CLAVE, idioma);
    } catch {
      /* sin almacenamiento: solo dura la sesión */
    }
  }, [idioma]);

  const valor = useMemo(() => ({ idioma, cambiarIdioma: setIdioma, t: DICCIONARIOS[idioma] }), [idioma]);
  return <IdiomaContext.Provider value={valor}>{children}</IdiomaContext.Provider>;
};

export const useIdioma = () => useContext(IdiomaContext);
